export enum NotificationId {
  SelectedMarksChanged = 'selected-marks-changed',
  ParameterChanged = 'parameter-changed',
  FilterChanged = 'filter-changed',
  ExtensionDialogUpdate = 'extension-dialog-update',
  SettingsChanged = 'settings-changed',
  ContextMenuClick = 'context-menu-click',
  TestConversionNotification = 'test-conversion-notification'
}



// WEBPACK FOOTER //
// ../../../src/contract/Notifications.ts


// WEBPACK FOOTER //
// webpack:///src/contract/Notifications.ts